import React, { createContext, useContext, useState, useRef } from 'react';

const NotificationContext = createContext(null);
export const useNotify = () => useContext(NotificationContext);

let nextId = 1;

export const NotificationProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const remove = (id) => {
    setToasts((cur) => cur.filter((t) => t.id !== id));
    if (timers.current[id]) {
      clearTimeout(timers.current[id]);
      delete timers.current[id];
    }
  };

  const push = (type, title, message, ttl = 5000) => {
    const id = nextId++;
    setToasts((cur) => [...cur, { id, type, title, message }]);
    if (ttl > 0) {
      timers.current[id] = setTimeout(() => remove(id), ttl);
    }
    return id;
  };

  const api = {
    success: (title, message, ttl) => push('success', title, message, ttl),
    error:   (title, message, ttl) => push('error', title, message, ttl ?? 7000),
    info:    (title, message, ttl) => push('info', title, message, ttl),
    pending: (title, message) => push('pending', title, message, 0),
    remove,
  };

  return (
    <NotificationContext.Provider value={api}>
      {children}
      <div className="toast-stack" aria-live="polite" aria-atomic="true">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`}>
            <div className="toast-icon">
              {t.type === 'success' && '✓'}
              {t.type === 'error' && '✕'}
              {t.type === 'info' && 'i'}
              {t.type === 'pending' && <span className="toast-spin" />}
            </div>
            <div className="toast-body">
              {t.title && <div className="toast-title">{t.title}</div>}
              {t.message && <div className="toast-msg">{t.message}</div>}
            </div>
            <button className="toast-close" onClick={() => remove(t.id)}>×</button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
